import * as ko from "knockout";
import * as _ from "underscore";

import {LABELS} from "Core/Components/Translation/Locales";
import {
    BaseProperty,
    IPropertyDescription,
    IPropertySortOption
} from "Core/GeneralProperties/Managers/BaseProperty";
import {SortOrder} from 'QueryBuilder/Enums';

import ConfigurationsSortingPropertyTemplate from "Core/GeneralProperties/Managers/ConfigurationsSortingProperty/Templates/ConfigurationsSortingProperty.html";

ko.templates["Core/GeneralProperties/Managers/ConfigurationsSortingProperty/Templates/ConfigurationsSortingProperty"] = ConfigurationsSortingPropertyTemplate;

export class ConfigurationsSortingProperty extends BaseProperty {
    private _fields: KnockoutObservableArray<any>;
    private _selectedField: KnockoutObservable<any>;
    private _initialPropertyValue: KnockoutObservable<IPropertySortOption>;
    private _orderByDescending: KnockoutObservable<boolean>;
    private _disableOrderCheckbox: KnockoutComputed<boolean>;

    constructor(property: IPropertyDescription, propertyValue: IPropertySortOption) {
        super(property);

        this._fields = ko.observableArray([]);
        this._selectedField = ko.observable(null);
        this.Value = ko.observable(null);
        this._initialPropertyValue = ko.observable(propertyValue);
        this._orderByDescending = ko.observable(false);

        this._selectedField.subscribe((newValue)=>{
            if (newValue) {
                if (newValue.Id === 0) {
                    this._orderByDescending(false);
                }

                this.Value( { FieldId: newValue.Id, SortDirection: this._orderByDescending() ? SortOrder.Descending : SortOrder.Ascending });
            }
        });

        this._orderByDescending.subscribe((newValue) => {
            this.Value().SortOrder = newValue ? SortOrder.Descending : SortOrder.Ascending;
        });

        this._disableOrderCheckbox = ko.computed(() => this.Value() && this.Value().FieldId === 0);
    }

    GetTemplateName(): string {
        return "Core/GeneralProperties/Managers/ConfigurationsSortingProperty/Templates/ConfigurationsSortingProperty";
    }

    GetDefaultValue() {
        return {
            FieldId: 0,
            SortOrder: SortOrder.Ascending
        }
    }

    SetFields(fields: any)
    {
        const allowedFields = _.filter(fields, (field: any) => field.IsPrimaryKey || field.IsInteger);
        allowedFields.unshift({ Id: 0, GetNameTranslated: `${LABELS.SELECT_LABEL}...` });
        this._fields(allowedFields);

        const initialPropertyValue = this._initialPropertyValue();

        if (!initialPropertyValue){
            this.Value(this.GetDefaultValue());
            this._orderByDescending(false);
            return;
        }

        let value: IPropertySortOption = {
            FieldId : 0,
            SortOrder: SortOrder.Ascending
        };

        this.Value({ FieldId: 0, SortOrder: SortOrder.Ascending } );

        const field = _.find(this._fields(), (field)=>{
            return field.Id === initialPropertyValue.FieldId;
        });

        if (field) {
            value.FieldId = field.Id;
            this._selectedField(field);
        }

        const orderByDescending = initialPropertyValue.SortOrder === SortOrder.Descending;

        value.SortOrder = initialPropertyValue.SortOrder;
        this.Value(value);

        this._orderByDescending(orderByDescending);
        this._initialPropertyValue(null);
    }
}